import CancelButton from '../../atoms/buttons/modalButton';
import Container from '../../atoms/container/modalButtons';
import Focus from '../../../../shared/types/enums/focus';
import Modals from '../../../../shared/types/enums/modals';
import TranslationManager from '../../../../shared/assets/locale/translationsManager';
import useKeyboard from '../../../../shared/components/utils/hooks/useKeyboard';
import { ActivateModalButtonsProps as Props } from '../../../../shared/types/props/modal';
import {
  channelDown,
  channelUp,
} from '../../../../shared/store/thunks/channels.thunk';
import {
  popFocus,
  pushFocus,
} from '../../../../shared/store/slices/focus.slice';
import { setModal } from '../../../../shared/store/slices/modal.slice';
import { useAppDispatch, useAppSelector } from '../../../../shared/store/hooks';
import { useEffect } from 'react';
import { magicRemoteSelector } from '../../../../shared/store/slices/magicRemote.slice';

function ActivateModalButtons({ allowZapping = false }: Props) {
  const { enabled } = useAppSelector(magicRemoteSelector);
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(pushFocus(Focus.MODAL_BUTTONS));
    return () => {
      dispatch(popFocus());
    };
  }, []);

  useKeyboard({
    focus: Focus.MODAL_BUTTONS,
    stopPropagation: true,
    keyDownHandler: (key: string) => {
      switch (key) {
        case 'UP':
        case 'CHANNEL_UP':
          allowZapping && dispatch(channelUp());
          break;
        case 'DOWN':
        case 'CHANNEL_DOWN':
          allowZapping && dispatch(channelDown());
          break;
        case 'SELECT':
          dispatch(
            setModal(
              allowZapping ? Modals.ANONYMOUS_ZAPPER : Modals.ANONYMOUS_GENERIC
            )
          );
          break;
      }
    },
  });

  return (
    <Container>
      <CancelButton
        focused={!enabled}
        onClick={() =>
          dispatch(
            setModal(
              allowZapping ? Modals.ANONYMOUS_ZAPPER : Modals.ANONYMOUS_GENERIC
            )
          )
        }
      >
        {TranslationManager.get('MODAL.ACTIVATE.BUTTONS.CANCEL')}
      </CancelButton>
    </Container>
  );
}

export default ActivateModalButtons;
